// import { ExpenseAuth, ManageAuth } from '@/interface/api/role'

// 权限对应页面
// type Key = keyof ExpenseAuth | keyof ManageAuth
type AuthToPath = {
  [key in string]: string
}
const authToPath: AuthToPath = {
  qygl: '/home/firm',
  'plkj.list': '/home/invoicing/blue/batch-opener',
  // 'plkj.listLz': '/home/invoicing/blue/opened',
  'hzfpkj.list': '/home/invoicing/red/process', // 红字确认单处理
  'hzfpkj.hclr': '/home/invoicing/red/confirm', // 红字发票确认录入
  'hzfpkj.dklist': '/home/invoicing/red/opened', // 待开红字发票列表
  kpjl: '/home/invoicing/reocrd', // 开票记录
  dkgx: '/home/use-invoice/deduction', // 抵扣勾选
  fprz: '/home/use-invoice/into-account', // 入账勾选
  ypgzpz: '/home/use-invoice/rule-setting', // 用票规则配置
  fpc: '/home/invoice-pool/sales-invoice', // 发票池
  fpgj: '/home/invoice-pool/invoices-collect', // 发票归集
  lqdwxx: '/admin/firm-lists', // 企业绑定管理
  user: '/admin/account-lists', // 账户管理
  role: '/role-auth/1', // 角色
  yygl: '/admin/application', // 应用管理
  cspz: '/admin/parameter-configuration/mail-box', // 发件邮箱配置
  'cspz.emaipz': '/admin/parameter-configuration/mail-box', // 发件邮箱配置
  'cspz.sxedpz': '/admin/parameter-configuration/credit-granting', // 授信额度配置
  'cspz.xeyjpz': '/admin/parameter-configuration/limit-warning', // 限额预警配置
  log: '/admin/log/login', // 调用日志
  'log.lqlog': '/admin/log/transfer', // 调用日志
  'log.actionRecord': '/admin/log/login', // 数据日志
  'log.systemLog': '/admin/log/system', // 系统日志
  'log.loginLog': '/adming/log/data' // 登录日志
}
export default authToPath
